// src/locales/tr.js

export const tr = {
    // Navigation
    nav: {
        title: 'Turf Manager',
        upload: 'Veri Yükleme',
        dashboard: 'Genel Gösterge Paneli',
        data: 'TurfBox Verileri',
        units: 'Üniteler',
        irrigation: 'Sulama',
        heating: 'Isıtma',
        map: 'Sensör Haritası',
        records: 'Kayıt',
        team: 'Takım',
        field: 'Saha',
        allTeams: 'Tüm Takımlar',
        allFields: 'Tüm Sahalar',
        uploadedFile: 'Yüklenen Dosya',
        profile: 'Admin',
        language: 'Dil',
        english: 'İngilizce',
        turkish: 'Türkçe',
        settings: 'Ayarlar',
        reports: 'Raporlar',
        help: 'Yardım',
        logout: 'Çıkış Yap',
        notifications: 'Bildirimler',
        unread: 'okunmamış',
        viewAll: 'Tümünü Gör',
        reports: 'Raporlar',
        infoTeam: 'Takım: {team}',
        infoField: 'Saha: {field}',
        infoRecordCount: 'TurfBox Veri Sayısı: {count}',
        infoDeviceCount: 'TurfBox Cihaz Sayısı: {count}',
        infoUnitCount: 'Ünite Adedi:',
        infoIrrigationSystems: 'Sulama Sistemleri:',
        infoHeatingSystems: 'Isıtma Sistemleri:',
        noData: 'Veri Yok'
    },

    // Reports
    reports: {
        title: 'Hazır Raporlar',
        subtitle: 'Sistem tarafından otomatik oluşturulan performans ve durum raporları',
        monthlyPerformance: 'Aylık Performans Raporu',
        monthlyPerformanceDesc: 'Tüm sahaların aylık su tüketimi, gübreleme ve bakım performansı analizi.',
        deviceStatus: 'Cihaz Durum Raporu',
        deviceStatusDesc: 'Aktif/Pasif cihazlar, batarya durumları ve kalibrasyon geçmişi.',
        usageStats: 'Kullanım İstatistikleri',
        usageStatsDesc: 'Kullanıcı girişleri, veri yükleme sıklığı ve sistemsel aktiviteler.',
        preparing: 'Rapor hazırlanıyor, lütfen bekleyin...'
    },

    // Upload Page
    upload: {
        title: 'Excel Veri Yükleme',
        subtitle: 'TurfBox sensör verilerini sisteme yükleyin',
        clickToUpload: 'Excel dosyanızı yüklemek için tıklayın veya sürükleyin',
        supportedFormats: 'Desteklenen formatlar: .xlsx, .xls, .csv',
        supportedFormatsWithCount: 'Desteklenen formatlar: .xlsx, .xls, .csv ({count} kayıt)',
        fileSelected: 'Seçili',
        processing: 'Veriler işleniyor... Lütfen bekleyin.',
        success: 'kayıt başarıyla yüklendi!',
        successMessage: 'Veriler TurfBox formatına dönüştürüldü. Aşağıda önizleme yapabilirsiniz.',
        error: 'Dosya yüklenirken hata oluştu. Lütfen dosya formatını kontrol edin.',
        unknownTeam: 'Bilinmeyen Takım',
        unknownField: 'Bilinmeyen Saha',
        fileFormat: 'Dosya Adı Formatı',
        fileFormatExample: 'Örnek: Galatasaray-TurkTelekom-20251230-Antrenman.xlsx',
        exportExcel: 'Excel\'e Aktar',
        totalRecords: 'Toplam Kayıt',
        activeDevices: 'Aktif Cihaz',
        avgTemperature: 'Ort. Sıcaklık',
        avgMoisture: 'Ort. Nem',
        avgSoilMoisture: 'Ort. Toprak Nemi',
        loadedFromExcel: 'Excel\'den yüklendi',
        onlineSensors: 'Online sensörler',
        airTempAverage: 'Hava sıcaklığı ortalaması',
        moistureAverage: 'Nem ortalaması',
        dataPreview: 'Veri Önizleme',
        showing: 'gösteriliyor',
        of: '/',
        total: 'toplam',
        previewLimit: 'İlk 50 kayıt görüntüleniyor / Toplam {total} kayıt',
        maxFileSize: 'Maksimum dosya boyutu: 50MB',
        noteLabel: 'ℹ️ Not:',
        performanceNote: 'Performans için yalnızca ilk 50 kayıt gösteriliyor.',
        exportAll: 'Tüm verileri Excel\'e aktarın →',
        exportAllWithCount: 'Tüm {total} kaydı Excel\'e aktarabilirsiniz.',
        exportHeaders: {
            device: 'Cihaz',
            location: 'Lokasyon',
            airTemp: 'Hava Sıcaklığı (°C)',
            humidity: 'Nem (%)',
            co2: 'CO₂ (ppm)',
            wind: 'Rüzgar (km/h)',
            lux: 'Lux',
            soilMoisture: 'Toprak Nemi (%)',
            soilTemp: 'Toprak Sıcaklığı (°C)',
            ph: 'pH',
            ec: 'EC (mS)',
            status: 'Durum'
        },
        exportSheetName: 'TurfBox Verileri',
        exportFilePrefix: 'TurfBox_Veriler',
        tableHeaders: {
            index: 'No',
            device: 'Cihaz',
            location: 'Lokasyon',
            airTemp: 'Hava Sıc.',
            humidity: 'Nem',
            co2: 'CO₂',
            wind: 'Rüzgar',
            lux: 'Lux',
            soilMoisture: 'T.Nem',
            soilTemp: 'T.Sıc.',
            status: 'Durum'
        },
        previewSummary: 'Veri Önizleme (İlk 20 Kayıt / Toplam {total})'
    },

    // Dashboard
    dashboard: {
        title: 'Genel Gösterge Paneli',
        subtitle: 'Tüm sensör verilerinin özeti ve analizleri',
        liveWeather: 'Anlık Hava Durumu',
        feelsLike: 'Hissedilen',
        humidity: 'Nem',
        wind: 'Rüzgar',
        visibility: 'Görüş',
        lastUpdate: 'Son güncelleme',
        loading: 'Yükleniyor...',
        noData: 'Veri alınamadı',
        location: '📍 Kocaeli, Türkiye',
        weatherSource: 'Kaynak: Google Maps (Demo)',
        totalRecordsAria: 'Toplam kayıtlar tablosuna git',
        activeDevicesAria: 'Aktif cihazlar tablosuna git',
        zoneCountAria: 'Zone sayısı haritasına git',
        totalAlertsAria: 'Bildirimler listesine git',
        totalRecords: 'Toplam Kayıt',
        totalTurfBoxRecords: 'Toplam TurfBox Kayıt Sayısı',
        allMeasurements: 'Tüm sensör ölçümleri',
        activeDevices: 'Aktif Cihaz',
        sensors: 'TurfBox sensörleri',
        turfBoxDeviceCount: 'Toplam TurfBox Cihaz Adedi',
        turfBoxSummary: 'TurfBox Özet',
        turfBoxActive: '{count} Aktif',
        turfBoxInactiveTotal: '{inactive} Pasif, Toplam {total}',
        units: 'Üniteler',
        unitDetail: 'Saha üniteleri',
        unitsSummary: 'Üniteler',
        unitsCount: '{count} adet',
        irrigationSystems: 'Sulama Sistemleri',
        irrigationDetail: 'Sulama sistem listesi',
        irrigationSummary: 'Sulama',
        irrigationDuration: '{minutes} dk',
        irrigationTodayTotal: 'Bugün toplam',
        heatingStatus: 'Isıtma',
        heatingStatusDetail: 'Isıtma sistemi durumu',
        heatingSummary: 'Isıtma',
        online: 'Online',
        offline: 'Offline',
        viewDetails: 'Detayları Gör',
        deviceLabel: 'Cihaz',
        selectDevice: 'Cihaz seçin',
        zoneCount: 'Zone Sayısı',
        locations: 'Farklı lokasyonlar',
        totalAlerts: 'Toplam Uyarı',
        needsAttention: 'Dikkat gerektiren',
        environmental: 'Çevresel Koşullar',
        chartDateRange: 'Grafik tarih aralığı',
        chartDateRangeHint: 'Tarihler UTC olarak yorumlanır.',
        startDate: 'Başlangıç',
        endDate: 'Bitiş',
        apply: 'Uygula',
        clear: 'Temizle',
        temperature: 'Sıcaklık',
        airAvg: 'Hava (Ort.)',
        soilAvg: 'Toprak (Ort.)',
        range: 'Aralık',
        optimal: 'Optimal seviyede',
        outOfRange: 'İdeal aralık dışında',
        moisture: 'Nem',
        illumination: 'Aydınlatma',
        other: 'Diğer',
        alerts: 'Dikkat Gerektiren Durumlar',
        lowMoisture: 'Düşük Nem',
        highTemp: 'Yüksek Sıcaklık',
        lowPH: 'Düşük pH',
        highPH: 'Yüksek pH',
        lowMoistureDetail: 'Zone < 20% nem',
        highTempDetail: 'Zone > 20°C',
        lowPHDetail: 'Zone < 6.0 pH',
        highPHDetail: 'Zone > 7.5 pH',
        weatherPartlyCloudy: 'Parçalı bulutlu',
        deviceDistribution: 'Cihaz Bazında Nem Dağılımı',
        zoneDistribution: 'Zone Bazında Sıcaklık Dağılımı'
    },

    // Lists
    lists: {
        totalFiles: 'Toplam dosya: {count}',
        empty: {
            title: 'Henüz veri bulunamadı',
            description: 'Bu alanda özet tablo görebilmek için manifest dosyasına kayıt ekleyin.'
        },
        table: {
            index: '#',
            file: 'Dosya',
            folder: 'Klasör'
        },
        heating: {
            title: 'Isıtma Listesi',
            subtitle: 'Isıtma sistem dosyalarının özeti',
            filters: {
                title: 'Filtreler',
                subtitle: 'Isıtma kayıtlarını süz',
                system: 'Sistem',
                date: 'Tarih Aralığı',
                startDate: 'Başlangıç',
                endDate: 'Bitiş',
                status: 'Durum',
                apply: 'Uygula',
                all: 'Tümü'
            },
            table: {
                timestamp: 'Tarih/Saat',
                system: 'Sistem',
                inletTemp: 'Giriş Sıc.',
                outletTemp: 'Çıkış Sıc.',
                deltaT: 'Delta T',
                pressure: 'Basınç',
                status: 'Durum'
            }
        },
        irrigation: {
            title: 'Sulama Listesi',
            subtitle: 'Sulama sistem dosyalarının özeti',
            tabs: {
                valves: 'Vana Listesi',
                soil: 'Toprak Verisi'
            },
            table: {
                valves: {
                    valve: 'Vana',
                    location: 'Lokasyon',
                    status: 'Durum',
                    actions: 'İşlemler'
                },
                soil: {
                    location: 'Lokasyon',
                    soilTemperature: 'Toprak Sıcaklığı',
                    soilMoisture: 'Toprak Nemi',
                    lastIrrigation: 'Son Sulama',
                    status: 'Durum'
                }
            },
            actions: {
                soilData: 'Toprak Verisi'
            },
            empty: {
                title: 'Toprak verisi bulunamadı',
                description: 'Bu sekmede içerik görmek için toprak verisi dosyalarını yükleyin.'
            }
        },
        units: {
            title: 'Ünite Listesi',
            subtitle: 'Ünite dosyalarının özeti'
        }
    },

    // Notifications
    notifications: {
        subtitle: 'Sistemden gelen son bildirimler',
        lowMoistureDetected: '{count} zone\'da düşük nem tespit edildi',
        newDataLoaded: 'Yeni veri yüklendi: {count} kayıt',
        systemUpdateComplete: 'Sistem güncellemesi tamamlandı',
        minutesAgo: '{count} dk önce',
        hoursAgo: '{count} saat önce',
        types: {
            warning: 'Uyarı',
            info: 'Bilgi',
            success: 'Başarılı'
        }
    },

    // Data Loader
    dataLoader: {
        loadIssueTitle: 'Veri Yükleme Sorunu',
        fileLocationLabel: '📁 Dosya Konumu:',
        step1Prefix: 'Excel dosyalarınızı',
        step1Suffix: 'klasörüne ekleyin',
        step2Label: 'Dosya isimleri:',
        step3Suffix: 'içindeki dosya listesini güncelleyin',
        sampleFileNames: '📝 Örnek Dosya İsimleri:',
        retry: 'Tekrar Dene',
        loadingTitle: 'Veriler Yükleniyor',
        loadingMessage: 'Excel dosyaları okunuyor, lütfen bekleyin...',
        consoleHintPrefix: 'Detaylı bilgi için',
        consoleHintSuffix: '\'u (F12) kontrol edin',
        loadErrorEmpty: 'Veri yüklenemedi veya dosyalar boş',
        loadError: 'Excel dosyaları yüklenirken bir hata oluştu'
    },

    // TurfBox Table
    table: {
        title: 'TurfBox Verileri',
        totalGroups: 'Toplam Grup',
        deviceLocation: 'Cihaz × Lokasyon',
        totalRecords: 'Toplam Kayıt',
        filtered: 'Filtrelenmiş',
        avgMoisture: 'Ort. Nem',
        soilMoisture: 'Toprak nemi',
        avgTemp: 'Ort. Sıcaklık',
        avgPH: 'Ort. pH',
        soilTemp: 'Toprak sıcaklığı',
        dateRange: 'Tarih Aralığı',
        all: 'Tümü',
        noFilter: 'Filtre yok',
        filteredData: 'Filtrelenmiş veri',
        dateFilter: 'Tarih Filtresi',
        clearFilter: 'Filtreyi Temizle',
        startDate: 'Başlangıç Tarihi',
        endDate: 'Bitiş Tarihi',
        quickFilters: 'Hızlı Filtreler',
        last24Hours: 'Son 24 Saat',
        last7Days: 'Son 7 Gün',
        last30Days: 'Son 30 Gün',
        allData: 'Tüm Veriler',
        activeFilter: 'Aktif Filtre',
        availableRange: 'Mevcut veri aralığı',
        searchPlaceholder: 'Cihaz veya lokasyon ara...',
        allDevices: 'Tüm Cihazlar',
        allLocations: 'Tüm Lokasyonlar',
        device: 'Cihaz',
        location: 'Lokasyon',
        records: 'Kayıt',
        min: 'Min',
        max: 'Max',
        status: 'Durum',
        detail: 'Detay',
        hide: 'Gizle',
        optimal: 'Optimal',
        good: 'İyi',
        attention: 'Dikkat',
        summary: 'Özet Bilgiler',
        totalMeasurements: 'Toplam Ölçüm',
        airTemp: 'Hava Sıcaklığı',
        airHumidity: 'Hava Nemi',
        detailedRecords: 'Detaylı Kayıtlar',
        last20Records: 'Son',
        showingFirst: 'kayıttan ilk',
        showing: 'gösteriliyor',
        noRecords: 'Kayıt bulunamadı',
        changeFilters: 'Filtreleri değiştirerek tekrar deneyin',
        howItWorks: 'Nasıl Çalışır?',
        infoText1: 'Her satır bir Cihaz × Lokasyon kombinasyonunu temsil eder',
        infoText2: 'Gösterilen değerler o grup için ortalama değerlerdir',
        infoText3: '"Detay" butonuna tıklayarak tüm bireysel kayıtları görebilirsiniz',
        infoText4: 'Durum renkleri: 🟢 Optimal, 🟡 İyi, 🔴 Dikkat (nem ve sıcaklık bazlı)',
        exportExcel: 'Excel\'e Aktar',
        dateFilterHint: 'Tarih aralığına göre filtreleme yapabilirsiniz.',
        noStart: 'Başlangıç yok',
        noEnd: 'Bitiş yok',
        filterSummary: '{filtered} kayıt / {total} toplam',
        sensorMap: 'Sensör Haritası',
        summaryWithContext: 'Özet Bilgiler - {device} ({location})',
        detailedRecordsWithCount: 'Detaylı Kayıtlar (Son {count} kayıt)',
        detailHeaders: {
            dateTime: 'Tarih/Saat',
            airTemp: 'Hava Sıc.',
            airHumidity: 'Hava Nem',
            wind: 'Rüzgar',
            lux: 'Lux',
            soilMoisture: 'T.Nem',
            soilTemp: 'T.Sıc.'
        },
        showingFirstRecords: 'Toplam {total} kayıttan ilk 20\'si gösteriliyor',
        statuses: {
            normal: 'Normal',
            critical: 'Kritik'
        },
        export: {
            device: 'Cihaz',
            location: 'Lokasyon',
            date: 'Tarih',
            airTemp: 'Hava Sıcaklığı (°C)',
            humidity: 'Nem (%)',
            recordCount: 'Kayıt Sayısı',
            avgAirTemp: 'Hava Sıc. (°C)',
            avgHumidity: 'Nem (%)',
            co2: 'CO₂ (ppm)',
            wind: 'Rüzgar (km/h)',
            lux: 'Lux',
            soilMoisture: 'Toprak Nemi (%)',
            avgSoilMoisture: 'Toprak Nemi (%)',
            minMoisture: 'Min Nem (%)',
            maxMoisture: 'Max Nem (%)',
            avgSoilTemp: 'Toprak Sıc. (°C)',
            minTemp: 'Min Sıc. (°C)',
            maxTemp: 'Max Sıc. (°C)',
            ph: 'pH',
            ec: 'EC (mS)',
            status: 'Durum',
            lastUpdate: 'Son Güncelleme',
            sheetName: 'TurfBox Özet',
            fileNamePrefix: 'TurfBox_Ozet'
        },
        paginationSummary: '{start} - {end} arası gösteriliyor (Toplam {total} kayıt)',
        pageLabel: 'Sayfa {current} / {total}'
    },

    // Sensor Map
    map: {
        title: 'Sensör Haritası - 30 Zone',
        activeZones: 'Aktif Zone',
        avgMoisture: 'Ort. Nem',
        avgTemp: 'Ort. Sıcaklık',
        avgPH: 'Ort. pH',
        lowMoisture: 'Düşük Nem',
        highTemp: 'Yüksek Sıc.',
        soilMoisture: 'Toprak Nemi',
        temperature: 'Sıcaklık',
        phLevel: 'pH Seviyesi',
        fieldView: 'Saha Görünümü',
        clickForDetails: 'Zone\'a tıklayarak detayları görüntüleyin',
        colorLegend: 'Renk Açıklaması',
        dry: 'Kuru',
        ideal: 'İdeal',
        wet: 'Islak',
        acidic: 'Asidik',
        basic: 'Bazik',
        zoneDetails: 'Zone',
        details: 'Detaylar',
        close: 'Kapat',
        lastUpdate: 'Son Güncelleme',
        criticalLegend: 'Kritik (nem < 20% / sıcaklık > 20°C)',
        normal: 'Normal',
        zoneDetailsTitle: 'Zone {zone} - Detaylar',
        soilTemp: 'Toprak Sıcaklığı',
        airTemp: 'Hava Sıcaklığı',
        airHumidity: 'Hava Nemi',
        unitLabel: 'Ünite',
        turfBoxLabel: 'TurfBox',
        heatingLabel: 'Isıtma',
        unitInfo: 'Ünite altyapısının temel durumu ve saha yerleşimi bilgisi.',
        turfboxInfo: 'TurfBox sensör istasyonu hakkında özet bilgi ve genel konum.',
        heatingInfo: 'Isıtma sistemi için temel çalışma ve konum bilgisi.',
        statuses: {
            normal: 'Normal',
            critical: 'Kritik',
            noData: 'Veri yok'
        }
    },

    // Common
    common: {
        search: 'Ara',
        filter: 'Filtre',
        export: 'Dışa Aktar',
        import: 'İçe Aktar',
        save: 'Kaydet',
        cancel: 'İptal',
        delete: 'Sil',
        edit: 'Düzenle',
        add: 'Ekle',
        back: 'Geri',
        next: 'İleri',
        previous: 'Önceki',
        loading: 'Yükleniyor...',
        error: 'Hata',
        success: 'Başarılı',
        warning: 'Uyarı',
        info: 'Bilgi',
        yes: 'Evet',
        no: 'Hayır',
        ok: 'Tamam',
        date: 'Tarih',
        time: 'Saat',
        name: 'Ad',
        description: 'Açıklama',
        actions: 'İşlemler'
    },

    // Units
    units: {
        totalUnits: 'Toplam Ünite: {count}',
        celsius: '°C',
        percent: '%',
        ppm: 'ppm',
        kmh: 'km/h',
        ms: 'm/s',
        miliSiemens: 'mS',
        km: 'km',
        lux: 'lux',
        filters: {
            title: 'Filtreler',
            subtitle: 'Arama ve tarih aralığına göre daraltın',
            unit: 'Ünite',
            startDate: 'Başlangıç Tarihi',
            endDate: 'Bitiş Tarihi',
            apply: 'Filtrele',
            all: 'Tümü'
        },
        table: {
            dateTime: 'Tarih/Saat',
            unit: 'Ünite',
            unitFallback: 'Ünite',
            location: 'Lokasyon',
            tempHumidity: 'Sıcaklık/Nem',
            temperature: 'Sıcaklık',
            humidity: 'Nem',
            status: 'Durum',
            actions: 'İşlemler',
            noData: 'Veri Yok'
        },
        status: {
            normal: 'Normal',
            attention: 'Dikkat'
        },
        actions: {
            detail: 'Detay',
            sensorMap: 'Sensör Haritası'
        },
        graphView: {
            button: 'Grafik Görünüm',
            title: 'Grafik Görünüm',
            subtitle: 'TurfBox Veri Listesi görünümü için özet kutucuklar.',
            lastUpdate: 'Son güncelleme: {value}',
            cards: {
                totalUnits: 'Toplam Ünite',
                totalUnitsHint: 'Filtrelenen sonuçlar',
                attention: 'Dikkat Gereken',
                attentionHint: 'Sıcaklık/nem uyarıları',
                avgTemperature: 'Ortalama Sıcaklık',
                avgTemperatureHint: 'Son 24 saatlik ölçüm',
                avgHumidity: 'Ortalama Nem',
                avgHumidityHint: 'Sensör ortalaması'
            }
        },
        detail: {
            subtitle: 'Ünite Detayı',
            summary: 'Özet Bilgiler',
            fileInfo: 'Dosya Bilgileri',
            fileName: 'Dosya Adı',
            locationLabel: 'Lokasyon',
            back: 'Listeye Dön',
            emptyTitle: 'Ünite bulunamadı',
            emptyDescription: 'Detay görüntülemek için listeden bir ünite seçin.'
        }
    }
};
